import React from "react"
import { FadeText } from "./globalStyles"

const HeaderMessege = () => {
  return (
    // <header>
    <FadeText>
      <h1>
        {" "}
        Hello my name is : <i>Hamzah</i>
      </h1>
    </FadeText>
    // </header>
  )
}
export default HeaderMessege
